var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactionsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2036 14.8398C15.2036 15.2195 14.9215 15.5333 14.5554 15.583L14.4536 15.5898L0.835835 15.5898C0.421622 15.5898 0.0858354 15.2541 0.0858354 14.8398C0.0858354 14.4601 0.367989 14.1464 0.734065 14.0967L0.835835 14.0898L14.4536 14.0898C14.8678 14.0898 15.2036 14.4256 15.2036 14.8398Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46111 18.3857C5.75468 18.6779 5.75578 19.1528 5.46356 19.4464C5.19791 19.7133 4.7813 19.7384 4.48719 19.5213L4.4029 19.4488L0.306237 15.3711C0.0384829 15.1045 0.014142 14.6863 0.233213 14.3922L0.306237 14.3079L4.4029 10.2302C4.69647 9.93795 5.17135 9.93905 5.46356 10.2326C5.72921 10.4995 5.75245 10.9162 5.53392 11.2093L5.46111 11.2933L1.89912 14.8391L5.46111 18.3857Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9171 4.91113C17.9171 5.29083 17.635 5.60462 17.2689 5.65429L17.1671 5.66113L3.54934 5.66113C3.13512 5.66113 2.79934 5.32535 2.79934 4.91113C2.79934 4.53144 3.08149 4.21764 3.44757 4.16798L3.54934 4.16113L17.1671 4.16113C17.5813 4.16113 17.9171 4.49692 17.9171 4.91113Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6968 4.37972C17.9646 4.64624 17.9889 5.06449 17.7699 5.3586L17.6968 5.44283L13.6002 9.52061C13.3066 9.81282 12.8317 9.81172 12.5395 9.51815C12.2739 9.25127 12.2506 8.83455 12.4691 8.54145L12.542 8.4575L16.1051 4.91105L12.542 1.36505C12.2751 1.0994 12.2499 0.682793 12.4671 0.388679L12.5395 0.304393C12.8052 0.0375115 13.2218 0.0123428 13.5159 0.229518L13.6002 0.301942L17.6968 4.37972Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionsIcon);
export default __webpack_public_path__ + "static/media/transactionsIcon.cc619e9ae01b7649662005d3e5348698.svg";
export { ForwardRef as ReactComponent };